import ReactMarkdown from 'react-markdown';
import { Button } from 'antd';
import React from 'react';
import '../assets/css/emails.css';

export interface TrialEmailContentProps {
  day: number | string;
  title?: React.ReactNode;
  content?: Array<string>;
  signOff?: Array<string>;
  callToAction?: string | null;
  secondaryCallToAction?: string | null;
  actionHref?: string | null;
  secondaryActionHref?: string | null;
  videoURL?: string | null;
  videoPoster?: string | null;
}

function TrialEmailContent({
  day = 1,
  title = null,
  content = [],
  signOff = ['**The swimbooker Team**'],
  callToAction = null,
  secondaryCallToAction = null,
  actionHref = null,
  secondaryActionHref = null,
  videoURL = null,
  videoPoster = null,
}: TrialEmailContentProps) {
  return (
    <div className='marketing-email-content mx-auto bg-white text-base/[1.5715]]'>
      {videoURL && (
        <video
          className='marketing-video mx-auto my-5'
          width='288'
          controls
          autoPlay
          controlsList='nodownload'
          disablePictureInPicture
          poster={videoPoster ?? undefined}
        >
          <source src={videoURL} type='video/mp4' />
          Your browser does not support playing mp4 videos. Please try the link
          here instead: <a href={videoURL}>{videoURL}</a>
        </video>
      )}

      <h1 className='mb-8 mt-8 text-center text-2xl font-bold'>
        {title ?? (
          <>
            DAY {day} | swimbooker{' '}
            <strong className='font-montserrat'>PLUS</strong>
          </>
        )}
      </h1>

      {content &&
        content.map((c, i) => (
          <ReactMarkdown key={`content-${i}`}>{c}</ReactMarkdown>
        ))}

      {secondaryCallToAction && (
        <p>
          <a href={(secondaryActionHref || actionHref) ?? undefined}>
            {secondaryCallToAction}
          </a>
        </p>
      )}

      <div className='email-sign-off'>
        {signOff &&
          signOff.map((c, i) => (
            <ReactMarkdown key={`sign-off-${i}`}>{c}</ReactMarkdown>
          ))}
      </div>

      {callToAction && (
        <Button
          className='mx-auto mb-10 mt-10 h-fit w-full max-w-[400px] whitespace-normal rounded-full border border-blue-300 bg-gradient-to-b from-blue to-[#1B4C74] p-2.5 text-center text-lg font-semibold text-white'
          href={actionHref ?? undefined}
        >
          <span className='text-white'>{callToAction}</span>
        </Button>
      )}
    </div>
  );
}

export default TrialEmailContent;
